var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 1H1.91667C1.41041 1 1 1.41041 1 1.91667V8.33333C1 8.83959 1.41041 9.25 1.91667 9.25H6.5C7.00626 9.25 7.41667 8.83959 7.41667 8.33333V1.91667C7.41667 1.41041 7.00626 1 6.5 1Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5833 1H12C11.4937 1 11.0833 1.41041 11.0833 1.91667V4.66667C11.0833 5.17293 11.4937 5.58333 12 5.58333H16.5833C17.0896 5.58333 17.5 5.17293 17.5 4.66667V1.91667C17.5 1.41041 17.0896 1 16.5833 1Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5833 9.25H12C11.4937 9.25 11.0833 9.66041 11.0833 10.1667V16.5833C11.0833 17.0896 11.4937 17.5 12 17.5H16.5833C17.0896 17.5 17.5 17.0896 17.5 16.5833V10.1667C17.5 9.66041 17.0896 9.25 16.5833 9.25Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 12.9167H1.91667C1.41041 12.9167 1 13.3271 1 13.8333V16.5833C1 17.0896 1.41041 17.5 1.91667 17.5H6.5C7.00626 17.5 7.41667 17.0896 7.41667 16.5833V13.8333C7.41667 13.3271 7.00626 12.9167 6.5 12.9167Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/DashboardIcon.07f11f7ae695c9ee52b27fb3217cd582.svg";
export { ForwardRef as ReactComponent };